<template>
  <div class="floating-sidebar">
    <!-- 悬浮框主体 -->
    <div class="sidebar-container">
      <!-- 电话联系 -->
      <div class="sidebar-item"
           @mouseenter="showContactInfo('phone')"
           @mouseleave="hideContactInfo('phone')">
        <i class="fa fa-phone"></i>
        <span>电话联系</span>
      </div>

      <!-- 微信咨询 -->
      <div class="sidebar-item"
           @mouseenter="showContactInfo('wechat')"
           @mouseleave="hideContactInfo('wechat')">
        <i class="fa fa-weixin"></i>
        <span>微信咨询</span>
      </div>

      <!-- 公众号 -->
      <div class="sidebar-item"
           @mouseenter="showContactInfo('officialAccount')"
           @mouseleave="hideContactInfo('officialAccount')">
        <i class="fa fa-qrcode"></i>
        <span>公众号</span>
      </div>

      <!-- 返回顶部 - 仅在滚动时显示 -->
      <div v-if="showBackToTop"
           class="sidebar-item"
           @click="scrollToTop">
        <i class="fa fa-arrow-up"></i>
        <span>返回顶部</span>
      </div>
    </div>

    <!-- 联系信息显示框 -->
    <div v-show="activeInfo === 'phone'"
         class="contact-info phone-info">
      <div class="info-content">
        <p class="phone-number">186 0064 6605</p>
        <p class="work-time">周一至周五 9:00-18:00</p>
      </div>
      <div class="triangle"></div>
    </div>

    <div v-show="activeInfo === 'wechat'"
         class="contact-info wechat-info">
      <div class="info-content">
        <div class="qrcode-container">
          <img src="../assets/img/wxerweima.jpg"
               alt="微信二维码"
               class="qrcode">
        </div>
        <p class="wechat-tip">扫码添加客服微信</p>
      </div>
      <div class="triangle"></div>
    </div>

    <div v-show="activeInfo === 'officialAccount'"
         class="contact-info official-account-info">
      <div class="info-content">
        <div class="qrcode-container">
          <img src="../assets/img/gzherweima.jpg"
               alt="公众号二维码"
               class="qrcode">
        </div>
        <p class="account-name">关注我们的公众号</p>
      </div>
      <div class="triangle"></div>
    </div>

    <!-- <div v-show="activeInfo === 'backToTop'"
         class="contact-info back-to-top-info">
      <div class="info-content">
        <p>返回顶部</p>
      </div>
      <div class="triangle"></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'FloatingSidebar',
  data () {
    return {
      activeInfo: null,
      showBackToTop: false
    };
  },
  mounted () {
    // 监听滚动事件，控制返回顶部按钮显示
    window.addEventListener('scroll', this.handleScroll);
    // 初始检查
    this.handleScroll();
  },
  beforeDestroy () {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 显示联系信息
    showContactInfo (type) {
      this.activeInfo = type;
    },
    // 隐藏联系信息
    hideContactInfo (type) {
      // 只在鼠标离开的是当前激活的元素时才隐藏
      if (this.activeInfo === type) {
        this.activeInfo = null;
      }
    },
    // 滚动到顶部
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    // 处理滚动事件
    handleScroll () {
      // 当滚动超过100px时显示返回顶部按钮，否则隐藏
      this.showBackToTop = window.scrollY > 100;

      // 如果页面在顶部且当前显示的是返回顶部的提示框，则隐藏它
      if (window.scrollY <= 100 && this.activeInfo === 'backToTop') {
        this.activeInfo = null;
      }
    }
  }
};
</script>

<style scoped>
.floating-sidebar {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
}

.sidebar-container {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  color: #333;
}

.sidebar-item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-item:hover {
  background-color: #409eff;
  color: #fff;
}

.sidebar-item i {
  font-size: 20px;
  margin-bottom: 4px;
}

.sidebar-item span {
  font-size: 12px;
  white-space: nowrap;
}

/* .contact-info {
  right: 60px;
  min-width: 160px;
  padding: 10px;
} */
.contact-info {
  position: absolute;
  right: 100px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 15px;
  min-width: 200px;
  opacity: 1;
  /* visibility: hidden; */
  /* transform: translateX(10px); */
  transition: all 0.3s ease;
  z-index: 1000;
}

.contact-info.active {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.phone-info {
  top: 0;
}

.wechat-info {
  top: 60px;
}

.official-account-info {
  top: 120px;
}

.back-to-top-info {
  top: 180px;
}

.info-content {
  text-align: center;
}

.phone-number {
  font-size: 18px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 8px;
}

.work-time {
  font-size: 12px;
  color: #666;
}

.qrcode-container {
  margin-bottom: 10px;
}

.qrcode {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #eee;
  border-radius: 4px;
}

.wechat-tip,
.account-name {
  font-size: 14px;
  color: #333;
}

/* .triangle {
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #fff;
} */

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-sidebar {
    right: 10px;
  }

  .sidebar-container {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .sidebar-item {
    width: 100px;
    height: 100px;
    padding: 8px;
  }

  .sidebar-item i {
    font-size: 18px;
  }

  .sidebar-item span {
    font-size: 10px;
  }

  .qrcode {
    width: 100px;
    height: 100px;
  }

  .phone-number {
    font-size: 16px;
  }

  .wechat-tip,
  .account-name {
    font-size: 12px;
  }
}
</style>
